<template>
    <table class="w-full max-w-6xl my-6 text-sm lg:text-base" v-if="cart.length">
        <thead>
            <tr>
                <th class="text-left border-b-2 border-gray py-2 px-2">Product</th>
                <th class="text-right border-b-2 border-gray py-2 px-2">Price</th>
                <th v-if="!isTaxExemptCustomer" class="text-center border-b-2 border-gray py-2 px-2">Tax</th>
                <th class="text-cemter border-b-2 border-gray py-2 px-2">Quantity</th>
                <th class="text-right border-b-2 border-gray py-2 px-2">Total</th>
            </tr>
        </thead>
        <tbody>
            <shopping-cart-item
                v-for="item in cart"
                :key="item.product.id"
                :item="item"
                :isTaxExemptCustomer="isTaxExemptCustomer"
            />
        </tbody>
        <tfoot>
            <tr>
                <td class="pt-2 px-2 relative">
                    <jet-tertiary-button type="button" @click="emptyCart" class="absolute top-2">Empty Cart</jet-tertiary-button>
                </td>
                <th class="text-right pt-2 px-2" :colspan="isTaxExemptCustomer ? 2 : 3">Subtotal:</th>
                <td class="text-right pt-2 px-2">{{ toCurrency(cartSubtotal) }}</td>
            </tr>
            <tr v-if="delivery_fee && delivery_fee > 0">
                <th class="text-right px-2" :colspan="isTaxExemptCustomer ? 3 : 4">Delivery Fee:</th>
                <td class="text-right px-2">{{ toCurrency(delivery_fee) }}</td>
            </tr>
            <tr v-if="!isTaxExemptCustomer">
                <th class="text-right px-2" colspan="4">Tax:</th>
                <td class="text-right px-2">{{ toCurrency(tax) }}</td>
            </tr>
            <tr v-if="appliedCreditAmount && appliedCreditAmount > 0">
                <th class="text-right px-2" :colspan="isTaxExemptCustomer ? 3 : 4">Prepaid:</th>
                <td class="text-right px-2">{{ toCurrency(appliedCreditAmount) }}</td>
            </tr>
            <tr>
                <th class="text-right px-2" :colspan="isTaxExemptCustomer ? 3 : 4">Total:</th>
                <td class="text-right px-2">{{ toCurrency(totalAfterCredit) }}</td>
            </tr>
        </tfoot>
    </table>

    <div v-else class="my-6">
        <p class="text-lg mb-3">Your cart is currently empty.</p>

        <jet-tertiary-button :href="route('catalogue')">Continue Shopping</jet-tertiary-button>
    </div>
</template>

<script>
import { computed } from 'vue';
import UseCart from '@/Composables/UseCart';
import { computeOrderTotals } from '@/Composables/useOrderTotals';
import ShoppingCartItem from '@/Pages/Checkout/Partials/ShoppingCartItem.vue';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    components: {
        ShoppingCartItem,
        JetTertiaryButton,
    },

    props: ['isTaxExemptCustomer', 'delivery_fee', 'appliableCreditAmount'],

    setup (props) {
        const { cart, emptyCart } = UseCart(
            usePage().props.value.user,
            usePage().props.value.activeCustomer ? usePage().props.value.activeCustomer.tax_exempt : 0
        );

        const delivery_fee = computed(() => {
            return props.delivery_fee ? parseFloat(props.delivery_fee) : 0;
        });

        // Full order totals (cart + delivery) using same calculation as backend
        const orderTotals = computed(() => {
            const cartItems = cart.value || [];
            const virtualOrder = {
                order_items: cartItems.map(item => ({
                    id: item.product?.id,
                    price: item.price,
                    quantity: item.quantity,
                    tax: !!(item.product?.taxable)
                })),
                delivery_fee: delivery_fee.value,
                fee_for_delivery: delivery_fee.value,
                tax_exempt: null,
                customer: { tax_exempt: !!props.isTaxExemptCustomer },
                applied_credit_amount: 0
            };
            return computeOrderTotals(virtualOrder);
        });

        const tax = computed(() => orderTotals.value.tax);
        const total = computed(() => orderTotals.value.total);

        const appliedCreditAmount = computed(() => {
            const totalVal = total.value;
            const credit = parseFloat(props.appliableCreditAmount) || 0;
            if (credit > totalVal) return totalVal;
            return credit;
        });

        const totalAfterCredit = computed(() => {
            return total.value - appliedCreditAmount.value;
        });

        return {
            cart,
            cartSubtotal: computed(() => orderTotals.value.subtotal),
            delivery_fee,
            tax,
            appliedCreditAmount,
            total,
            totalAfterCredit,
            emptyCart,
        }
    },
}
</script>

<style>

</style>
